import React from 'react';

import { VideoButton } from './BFComponents';

const Debug = () => {
    return (
        <>
            <VideoButton id={"V5gvSvFh6NF4"} />
            <VideoButton id={"Vz35ELHuxfkw"} />
        </>
    )
}

export default Debug;

